import React from 'react';

import Select from 'components/Select';

import Filter from './Filter';

export const FilterSelect: React.FC<any> = ({
  name,
  depends,
  source,
  active,
  params,
  label,
  helper,
  ...props
}) => {
  return (
    <Filter
      name={name}
      depends={depends}
      source={source}
      active={active}
      params={params}
      component={({ field, area }) => {
        return (
          <Select
            {...field}
            {...props}
            helper={helper}
            error={area?.error?.message || area?.error}
            label={label}
            isLoading={area?.isLoading}
            disabled={active === false}
            data={(area?.data as []) || []}
          />
        );
      }}
    />
  );
};
